import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'
export default async (organizationId) => {
  const endpoint = `${apiEndpoints.organizations}/${organizationId}/sites`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.get(URL, { withCredentials: true }))
}
